// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CRGLogo {
  padding: 24px 29.5px 0px 29.5px;
}

/* Media Query for Screens Less Than 1223px Wide */
@media (max-width: 1223px) {
  .landingPage {
    padding-left: 125px;
    height: 100vw;
    width: -moz-fit-content !important ;
    width: fit-content !important ;
    margin-right: 125px;
  }
}

@media (max-width: 816px) {
  .CRGLogo {
    padding: 60px 0px 0px 0px;
  }
}

@media (max-width: 500px) {
  .landingPage {
    padding-left: 20px;
    height: 100vw;
    width: -moz-fit-content !important;
    width: fit-content !important;
    margin-right: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Menu.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA,kDAAkD;AAClD;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,mCAA8B;IAA9B,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,kCAAkC;IAClC,6BAA6B;IAC7B,iBAAiB;EACnB;AACF","sourcesContent":[".CRGLogo {\n  padding: 24px 29.5px 0px 29.5px;\n}\n\n/* Media Query for Screens Less Than 1223px Wide */\n@media (max-width: 1223px) {\n  .landingPage {\n    padding-left: 125px;\n    height: 100vw;\n    width: fit-content !important ;\n    margin-right: 125px;\n  }\n}\n\n@media (max-width: 816px) {\n  .CRGLogo {\n    padding: 60px 0px 0px 0px;\n  }\n}\n\n@media (max-width: 500px) {\n  .landingPage {\n    padding-left: 20px;\n    height: 100vw;\n    width: -moz-fit-content !important;\n    width: fit-content !important;\n    margin-right: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
